import { useEffect } from 'react';

const SEO = () => {
  useEffect(() => {
    // Add structured data to the page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': 'https://hubready.com/#organization',
          name: 'HubReady IT',
          url: 'https://hubready.com',
          logo: {
            '@type': 'ImageObject',
            url: 'https://hubready.com/logo512.png',
            width: 512,
            height: 512
          },
          sameAs: [
            'https://www.facebook.com/hubreadyit',
            'https://twitter.com/hubreadyit',
            'https://www.instagram.com/hubreadyit',
            'https://www.linkedin.com/company/hubreadyit'
          ],
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+1-305-610-1001',
            contactType: 'Customer Service',
            areaServed: 'US',
            availableLanguage: ['English']
          }
        },
        {
          '@type': 'LocalBusiness',
          '@id': 'https://hubready.com/#localbusiness',
          name: 'HubReady IT',
          image: 'https://hubready.com/logo512.png',
          '@id': 'https://hubready.com',
          url: 'https://hubready.com',
          telephone: '+1-305-610-1001',
          priceRange: '$$',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '2131 Hollywood Blvd., Suite 407A',
            addressLocality: 'Hollywood',
            addressRegion: 'FL',
            postalCode: '33020',
            addressCountry: 'US'
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 26.0112,
            longitude: -80.1495
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: [
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday'
            ],
            opens: '09:00',
            closes: '17:00'
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '5',
            reviewCount: '12'
          }
        },
        {
          '@type': 'WebSite',
          '@id': 'https://hubready.com/#website',
          url: 'https://hubready.com',
          name: 'HubReady IT',
          description: 'AI + IT Solutions for South Florida Businesses',
          publisher: {
            '@id': 'https://hubready.com/#organization'
          },
          inLanguage: 'en-US'
        },
        {
          '@type': 'WebPage',
          '@id': 'https://hubready.com/#webpage',
          url: 'https://hubready.com',
          name: 'HubReady IT - AI + IT Solutions for South Florida Businesses',
          isPartOf: {
            '@id': 'https://hubready.com/#website'
          },
          about: {
            '@id': 'https://hubready.com/#organization'
          },
          description: 'Professional IT services, cybersecurity, cloud solutions, and AI agents for businesses in Hollywood, FL. Expert support for medical, legal, marine, real estate, and construction industries.',
          inLanguage: 'en-US'
        },
        {
          '@type': 'Service',
          serviceType: 'IT Services',
          provider: {
            '@id': 'https://hubready.com/#organization'
          },
          areaServed: {
            '@type': 'State',
            name: 'Florida'
          },
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'IT Services',
            itemListElement: [
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Cybersecurity Services',
                  description: 'Comprehensive cybersecurity solutions to protect your business from threats'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Managed Antivirus',
                  description: 'Enterprise-grade antivirus protection and management'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Email Security',
                  description: 'Advanced email threat protection and spam filtering'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Data Backup Solutions',
                  description: 'Automated backup and disaster recovery services'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Help Desk Support',
                  description: '24/7 help desk support with 28-second average response time'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Office 365 Management',
                  description: 'Microsoft Office 365 setup, migration, and ongoing support'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Web Design & Development',
                  description: 'Custom website design and development services'
                }
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'AI Agents',
                  description: 'Custom AI agent development and integration'
                }
              }
            ]
          }
        }
      ]
    });

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default SEO;
